import axios from 'axios';

const headers = {
  'X-Requested-With': 'XMLHttpRequest',
};
// PRE-PROD ----------------------------------------------------------------->

// baseURL
export const baseURL = "https://v1.api.gainwix.app/"; //prod-v1
export const webSocketUrl = `https://v1.api.gainwix.app/`; // prod
// export const baseURL = 'http://localhost:3000/'; // preprod
// export const webSocketUrl = `http://localhost:8082/`; // preprod

// service prefix
export const webChatServicePrefix = 'api/v1/svc/webchat/'; //prod
export const teamsServicePrefix = 'api/v1/svc/team/'; //prod

// API Secret Key
const API_SECRET_KEY = "99f316f8-2c19-4632-b3c5-25518cd1e7a4"; // prod

// Site Key ---- recaptcha
export const sitekey = '6LfThrQqAAAAADPt2mC7Zc1QyQkIrLnEDeD6Aaiy'; //preprod

// config id --- facebook
export const configId = "963924375177412";  //prod-v1

// razorpay key
export const razorpay_key = "rzp_live_rVMlPoXXlvm9ru"; // prod-v1

// assets
export const gainwix_icons = "https://v1.assets.gainwix.app"; // prod-v1

// CDN
export const cdnURL = "https://storage.googleapis.com/cdn_api_gainwix_app"; // prod-v1

const AspApi = axios.create({
  baseURL: baseURL,
  headers,
});

AspApi.interceptors.request.use(
  async (config) => {
    config.headers = {
      Authorization: localStorage.getItem('authToken'),
      'X-ASP-APP-SECRET': API_SECRET_KEY,
    };
    return config;
  },

  (error) => {
    console.error(error);
    return error;
  },
);

AspApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error?.response?.data?.error === 'Token not logged in' ||
      error?.response?.data?.error === 'No active session found' ||
      error?.response?.data?.error === 'Token expired'
    ) {
      localStorage.removeItem('authToken');
      window.location.href = '/login';
      return error;
    } else return error;
  },
);

export const OpenAiApi = axios.create({
  baseURL: 'https://api.openai.com/v1',
  headers: {
    Authorization: `Bearer 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`,
    'Content-Type': 'application/json',
  },
});

// Teams api
export const goApi = axios.create({
  // baseURL: 'http://localhost:8080/',
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// WebChat Api
export const goWebChatApi = axios.create({
  // baseURL: 'http://localhost:8081/',
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

goApi.interceptors.request.use(
  async (config) => {
    config.headers = {
      // Authorization: localStorage.getItem('authToken'),
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      // 'X-ASP-APP-SECRET': API_SECRET_KEY,
    };
    return config;
  },

  (error) => {
    console.error(error);
    return error;
  },
);
goWebChatApi.interceptors.request.use(
  async (config) => {
    config.headers = {
      // Authorization: localStorage.getItem('authToken'),
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      // 'X-ASP-APP-SECRET': API_SECRET_KEY,
    };
    return config;
  },

  (error) => {
    console.error(error);
    return error;
  },
);

export default AspApi;
